export const CATEGORY_PATH_IDENTIFIER_DELIMITER = "|";
export const WOMEN_APPAREL_PATH_IDENTIFIER = "women|apparel_2";
export const SHOWROOM_PATH_IDENTIFIER = "showroom";
